var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulkPurchaseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 0.580078C1.23122 0.580078 0 1.8113 0 3.33008V17.8301C0 19.3489 1.23122 20.5801 2.75 20.5801H15.25C15.6642 20.5801 16 20.2443 16 19.8301V1.33008C16 0.915865 15.6642 0.580078 15.25 0.580078H2.75ZM1.5 17.5801V17.8301C1.5 18.5204 2.05964 19.0801 2.75 19.0801H14.5V16.0801H3C2.17157 16.0801 1.5 16.7517 1.5 17.5801ZM4.75 4.83008C4.33579 4.83008 4 5.16586 4 5.58008C4 5.99429 4.33579 6.33008 4.75 6.33008H11.25C11.6642 6.33008 12 5.99429 12 5.58008C12 5.16586 11.6642 4.83008 11.25 4.83008H4.75ZM4 9.58008C4 9.16586 4.33579 8.83008 4.75 8.83008H8.25C8.66421 8.83008 9 9.16586 9 9.58008C9 9.99429 8.66421 10.3301 8.25 10.3301H4.75C4.33579 10.3301 4 9.99429 4 9.58008Z",
    fill: "currentColor",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkPurchaseIcon);
export default __webpack_public_path__ + "static/media/bulk-purchase-icon.b56f684da8ca301fe04cb396cbf05f1e.svg";
export { ForwardRef as ReactComponent };